import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { BioParamsAddComponent } from './bio-params-add.component';
import { TranslateModule } from '../../../../shared/translate/translate.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [CommonModule, IonicModule, TranslateModule, FormsModule, ReactiveFormsModule],
  declarations: [BioParamsAddComponent],
  exports: [BioParamsAddComponent]
})
export class BioParamsAddModule { }
